import React from 'react';
import { ResultRow } from '../styles';

interface InteractiveResultRowProps {
  onSelect?: () => void;
  children: React.ReactNode;
}

export const InteractiveResultRow: React.FC<InteractiveResultRowProps> = ({
  onSelect,
  children,
}) => {
  return (
    <ResultRow
      $interactive={Boolean(onSelect)}
      role={onSelect ? 'button' : undefined}
      tabIndex={onSelect ? 0 : undefined}
      onClick={onSelect}
      onKeyDown={
        onSelect
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSelect();
              }
            }
          : undefined
      }
    >
      {children}
    </ResultRow>
  );
};
